<template>
    <div v-if="detail" style="padding:15px;background: white" v-html="detail"></div>
    <div class="no-data" v-else>暂无相关信息</div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";

    export default {
        data() {
            return {
                detail: "",
            }
        },
        methods: {},
        created() {
            this.detail = this.$store.state.transData || "";
        },
        mounted() {
        }
    }

</script>

<style lang="scss">
    @import "../assets/styles/common.css";
    .no-data{
        display: block;
        text-align: center;
        color: #aaa;
        font-size: 18px;
        line-height: 40px;
    }
</style>